<template>
<section class="area-section _edit-section">
    <div class="section-inner">
        <h2 class="heading-section"><span>取り扱い可能な地域</span></h2>
        <p>※取り扱い地域は表示されません。ショップからの検索と取り扱い可能に表示されます。</p>

        <div class="area-list-wrap">

            <!--add-->
            <ul class="list_area-lv1-ul area-list-item" v-for="(area_region, index) in getAreaRegionsList" v-bind:key="index">
                <div class="lv1-wrap">
                    <li class="list_area-lv1-li edit-select">
                        <select v-on:change="selectEditAreaRegion($event, area_region.id, area_region)">
                            <option hidden>{{area_region.name}}</option>
                            <option
                            v-for="pull_down_area_region in pullDownAreaRegionsList"
                            v-bind:key="pull_down_area_region.id"
                            v-bind:value="pull_down_area_region.id"
                            >{{ pull_down_area_region.name }}</option>
                        </select>
                    </li>
                    <div class="md_icon-btn">
                        <div class="inner"><SvgIconDelete v-on:click="deleteAreaRegions(area_region)"/></div>
                    </div>
                </div>
                <template v-for="(area_prefecture, index) in getAreaPrefecturesList(area_region)" v-bind:key="index">
                    <ul class="list_area-lv2-ul" >
                        <li class="list_area-lv2-li edit-select">
                            <select v-on:change="selectEditAreaPrefecture($event, area_region, area_prefecture.id)">
                                <option hidden>{{area_prefecture.name}}</option>
                                <option
                                v-for="pull_down_area_prefecture in pullDownAreaPrefecturesList(area_region)"
                                v-bind:key="pull_down_area_prefecture.id"
                                v-bind:value="pull_down_area_prefecture.id"
                                >{{ pull_down_area_prefecture.name }}</option>
                            </select>
                        </li>
                        <ul class="list_area-lv3-ul edit-check">
                            <li class="list_area-lv3-li form_checkbox">
                                <input type="checkbox" :name="'city-check-all' + (area_prefecture.id)" :id="'city-check-all' + (area_prefecture.id)"  v-on:change="changeAaareaCityALL(area_prefecture)">
                                <label :for="'city-check-all' + (area_prefecture.id)">
                                    <div class="check-mark"><span></span></div>
                                    <span>All</span>
                                </label>
                            </li>
                            <li class="list_area-lv3-li form_checkbox" v-for="(area_city, index) in area_prefecture.area_city" v-bind:key="index">
                                <input type="checkbox" :name="'city-check' + (area_city.area_prefecture_id)" :id="'city-check1-1' + (area_city.id)" :value="area_city" v-model="checked_area_citys">
                                <label :for="'city-check1-1' + (area_city.id)">
                                    <div class="check-mark"><span></span></div>
                                    <span>{{area_city.name}}</span>
                                </label>
                            </li>
                        </ul>

                    </ul>
                    <!--追加削除-->
                    <div class="md_add-del-wrap">
                        <button type="button" class="dele" v-on:click="deleteAreaPrefectures(area_prefecture.id, area_region)">
                            <div class="md_icon-btn">
                                <div class="inner"><SvgIconDelete /></div>
                            </div>
                        </button>
                        <button type="button" class="add" v-on:click="addAreaPrefectures(area_region.id)"><span></span><span></span></button>
                    </div>
                </template>
                <!-- 県を選択してください -->
                <ul v-if="showNullAreaPrefecture(area_region)" class="list_area-lv2-ul" >
                    <li class="list_area-lv2-li edit-select">
                        <select v-on:change="selectAreaPrefecture($event,area_region.area_prefectures)" id="mycheckbox">
                            <option hidden>県を選択</option>
                            <option
                            v-for="pull_down_area_prefecture in pullDownAreaPrefecturesList(area_region)"
                            v-bind:key="pull_down_area_prefecture.id"
                            v-bind:value="pull_down_area_prefecture.id"
                            >{{ pull_down_area_prefecture.name }}</option>
                        </select>
                    </li>
                </ul>


            </ul><!--add-->


            <!-- 地方を選択してください -->
            <!--add-->
            <ul v-if="null_area_regions" class="list_area-lv1-ul area-list-item">
                <div class="lv1-wrap">
                    <li class="list_area-lv1-li edit-select">
                        <select v-on:change="selectAreaRegion($event)">
                            <option hidden>地方を選択</option>
                            <option
                            v-for="pull_down_area_region in pullDownAreaRegionsList"
                            v-bind:key="pull_down_area_region.id"
                            v-bind:value="pull_down_area_region.id"
                            >{{ pull_down_area_region.name }}</option>
                        </select>
                    </li>
                    <!-- <div class="md_icon-btn">
                        <div class="inner"><SvgIconDelete /></div>
                    </div> -->
                </div>
            </ul><!--add-->

            <div v-if="add_area_regions_button" class="area-plus-card">
                <button type="button" class="icon" v-on:click="addAreaRegions()"></button>
            </div>

        </div><!--/.area-list-wrap-->

    </div><!--/.section-inner-->
</section>
</template>

<script>
    //Svg
    import SvgIconDelete from '@/components/EndUser/svg/SvgIconDelete'

    export default {
        components: {
            SvgIconDelete,
        },
        data() {
            return {
                //ーーーーーーーーーーーーーーーーーーーーーー地方ーーーーーーーーーーーーーーーーーーーーーーーー
                // 地方を選択してください表示・非表示
                null_area_regions: true,
                // 地方用のプラスボタン 表示・非表示
                add_area_regions_button: true,
                //プルダウン 最初は全てある。選択されたらここから消して表示させない
                pull_down_area_regions: [],
                //選択された地方を格納
                select_area_regions: [],

                //ーーーーーーーーーーーーーーーーーーーーー都道府県ーーーーーーーーーーーーーーーーーーーーーーーー
                // 県を選択してください
                null_area_prefecture: 0, //0:非表示、1:北海道、2:東北地方、、、8:九州地方
                //選択された県
                select_area_prefectures: [],

                //ーーーーーーーーーーーーーーーーーーーーーー市町村ーーーーーーーーーーーーーーーーーーーーーーー
                checked_area_citys: [],
            }
        },
        mounted: function() {
            // 編集の場合
            //表示用エリアデータ(全ての地方・県・市) this.$store.state.register.set.areas
            //DBに保存されているエリアデータ(idのみ region_id・prefecture_id・city_id) this.$store.state.detail.set.brand.area

            for(var i in this.$store.state.register.set.areas) {
                this.pull_down_area_regions.push(this.$store.state.register.set.areas[i]);
            }

            //DBに保存されているエリアデータがあれば
            if (this.$store.state.detail.set.brand.area) {
                // 地方
                for(var i in this.$store.state.register.set.areas) {
                    var area_region = this.$store.state.register.set.areas[i];
                    var check_index = this.$store.state.detail.set.brand.area.findIndex(detail_area => detail_area.region_id === area_region.id);

                    if(check_index != -1) {
                        // 選択されていればpush
                        this.select_area_regions.push(area_region);
                        this.$store.state.register.form.selectAreaLv1 = this.select_area_regions;
                        this.pull_down_area_regions = this.pull_down_area_regions.filter((pull_down_region) => {
                            return (pull_down_region.id != area_region.id);
                        });
                        //都道府県
                        for(var i in area_region.area_prefectures) {
                            var area_prefecture = area_region.area_prefectures[i];
                            var check_index = this.$store.state.detail.set.brand.area.findIndex(detail_area => detail_area.prefecture_id === area_prefecture.id);

                            if(check_index != -1) {
                                // 選択されていればpush
                                this.select_area_prefectures.push(area_prefecture);
                                this.$store.state.register.form.selectAreaLv2 = this.select_area_prefectures;

                                //市町村
                                for(var i in area_prefecture.area_city) {
                                    var area_city = area_prefecture.area_city[i];
                                    var check_index = this.$store.state.detail.set.brand.area.findIndex(detail_area => detail_area.city_id === area_city.id);

                                    if(check_index != -1) {
                                        // 選択されていればpush
                                        this.checked_area_citys.push(area_city);
                                        this.$store.state.register.form.selectAreaLv3 = this.checked_area_citys;
                                    }
                                }
                            }
                        }
                    }
                }
                if (this.select_area_regions.length == 7) {
                    this.null_area_regions = false;
                }
                if (this.select_area_regions.length == 8) {
                    this.null_area_regions = false;
                    this.add_area_regions_button = false;
                }
            }
        },
        computed: {
            getCategories() {
                var result = [];
                for(var i in this.categories) {
                    var category = this.categories[i];
                    if(category.master_id == this.currentId) {
                        result.push(category);
                    }
                }
                return result;
            },
            getAreaRegionsList() {
                return this.select_area_regions;
            },
            pullDownAreaRegionsList()  {
                // ここで地方全てから選ばれた地方を消してあげればいい
                // プルダウンをID順に並び替え
                this.pull_down_area_regions = this.pull_down_area_regions.sort((a, b) => {
                    return (a.id < b.id) ? -1 : (a.id > b.id) ? 1 : 0;
                });;
                return this.pull_down_area_regions;
            },
        },
        watch: {
            checked_area_citys: function () {
                this.$store.state.register.form.selectAreaLv1 = this.select_area_regions;
                this.$store.state.register.form.selectAreaLv2 = this.select_area_prefectures;
                this.$store.state.register.form.selectAreaLv3 = this.checked_area_citys;
            }
        },
        methods: {
            //ーーーーーーーーーーーーーーーーーーーーーーーーーー地方ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
            // 地方のプラスボタン
            addAreaRegions: function() {
                // 地方を選択してくださいを表示
                this.null_area_regions = true;

                // プルダウンにデータが残り一つになればプラスボタンは表示しない
                if (this.pull_down_area_regions.length == 1) {
                    this.add_area_regions_button = false;
                }
            },
            // 選択された地方を削除
            deleteAreaRegions: function(area_region) {
                var area_region_id = area_region.id;
                // 選択された地方データから消す
                this.select_area_regions = this.select_area_regions.filter((area_region) => {
                    return (area_region.id != area_region_id);
                });
                // 消された地方をvalueへ入れ、プルダウンを編集する
                var value = this.$store.state.register.set.areas.filter((area_region) => {
                    return (area_region.id == area_region_id);
                });
                this.pull_down_area_regions.push(value[0]);

                if (this.pull_down_area_regions.length) {
                    // プルダウンにデータがあれば表示する
                    this.add_area_regions_button = true;
                }

                // 消された地方をの県をプルダウンに戻す & 市のデータを削除
                for(var i in this.select_area_prefectures) {
                    if (this.select_area_prefectures[i].area_region_id == area_region_id) {
                        //市のデータを削除
                        this.checked_area_citys = this.checked_area_citys.filter((area_city) => {
                            return (this.select_area_prefectures[i].id != area_city.area_prefecture_id);
                        });
                        //消された地方をの県をプルダウンに戻す
                        area_region.area_prefectures.push(this.select_area_prefectures[i]);

                        //消された地方の県削除
                        this.select_area_prefectures.splice(i, 1);
                    }
                }
            },
            // 地方が選択された時
            selectAreaRegion: function(event) {
                var select_area_region_id = event.target.value;

                // 選択された地方データに選択された地方を増やす
                var value = this.pull_down_area_regions.filter((area_region) => {
                    return (area_region.id == select_area_region_id);
                });
                this.select_area_regions.push(value[0]);

                // プルダウンから選択された地方を減らす
                this.pull_down_area_regions = this.pull_down_area_regions.filter((area_region) => {
                    return (area_region.id != select_area_region_id);
                });
                
                // 地方を選択してくださいを非表示
                this.null_area_regions = false;

                // 県を選択してくださいを表示
                this.null_area_prefecture = select_area_region_id;
            },
            // 地方の選択を変更した時
            selectEditAreaRegion: function(event, before_select_area_region_id, area_region) {
                // 前に選択されてたIDがbefore_select_area_region_id
                // 今選択されたIDがselect_area_region_id
                var select_area_region_id = event.target.value;

                // 今選択された地方をvalueへ入れ、v_forを編集する
                var value = this.$store.state.register.set.areas.filter((region) => {
                    return (region.id == select_area_region_id);
                });
                for(var i in this.select_area_regions) {
                    if (this.select_area_regions[i].id == before_select_area_region_id) {
                        // 前に選択されてた地方を今選択された地方に変更
                        this.select_area_regions[i] = value[0];
                    }
                }

                // 前選択された地方をvalueへ入れ、プルダウンを編集する
                var value = this.$store.state.register.set.areas.filter((region) => {
                    return (region.id == before_select_area_region_id);
                });
                for(var i in this.pull_down_area_regions) {
                    // 今に選択されてた地方を前選択された地方に変更
                    if (this.pull_down_area_regions[i].id == select_area_region_id) {
                        this.pull_down_area_regions[i] = value[0];
                    }
                }

                // 消された地方をの県をプルダウンに戻す & 市のデータを削除
                for(var i in this.select_area_prefectures) {
                    if (this.select_area_prefectures[i].area_region_id == before_select_area_region_id) {
                        //市のデータを削除
                        this.checked_area_citys = this.checked_area_citys.filter((area_city) => {
                            return (this.select_area_prefectures[i].id != area_city.area_prefecture_id);
                        });
                        //消された地方をの県をプルダウンに戻す
                        area_region.area_prefectures.push(this.select_area_prefectures[i]);

                        //消された地方の県削除
                        this.select_area_prefectures.splice(i, 1);
                    }
                }

                // 県を選択してくださいを表示
                this.null_area_prefecture = select_area_region_id;
            },

            //ーーーーーーーーーーーーーーーーーーーーーーーーーー都道府県ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
            // 県のプラスボタン
            addAreaPrefectures: function(area_region_id) {
                // 県を選択してくださいを表示
                this.null_area_prefecture = area_region_id;
            },
            // 選択された県の削除
            deleteAreaPrefectures: function(area_prefecture_id, area_region) {
                // 今選択された県データをvalueへ
                let value = this.select_area_prefectures.filter((select_area_prefecture) => {
                    return (select_area_prefecture.id == area_prefecture_id);
                });
                // プルダウン表示のためにはプッシュ
                area_region.area_prefectures.push(value[0]);

                // 選択された県を削除
                this.select_area_prefectures = this.select_area_prefectures.filter((select_area_prefecture) => {
                    return (select_area_prefecture.id != area_prefecture_id);
                });

                // 消された県の市を削除
                this.checked_area_citys = this.checked_area_citys.filter((area_city) => {
                    return (area_city.area_prefecture_id !== area_prefecture_id);
                });
            },
            // 選択された地方の県データのみ表示
            getAreaPrefecturesList: function (area_region) {
                if (this.select_area_prefectures.length) {
                    return this.select_area_prefectures.filter(function (select_area_prefecture) {
                        return (area_region.id == select_area_prefecture.area_region_id);
                    })
                } else {
                    return null;
                }
            },
            // プルダウン 選択されていない県のみ表示
            pullDownAreaPrefecturesList: function (area_region) {

                let pull_prefectures = area_region.area_prefectures;

                // 北海道は対象外
                if (area_region.id != 1) {
                    for(let i in pull_prefectures) {
    
                        for(let index in this.select_area_prefectures) {
                            // 同じものがあれば削除
                            if (this.select_area_prefectures[index].id == pull_prefectures[i].id) {
                                pull_prefectures.splice(i, 1);
                            }
                        }
                    }
                } else {
                    for(let index in this.select_area_prefectures) {
                        // 同じものがあれば削除
                        if (this.select_area_prefectures[index].id == 1) {
                            pull_prefectures.splice(0, 1);
                        }
                    }
                }

                // プルダウンをID順に並び替え
                area_region.area_prefectures = area_region.area_prefectures.sort((a, b) => {
                    return (a.id < b.id) ? -1 : (a.id > b.id) ? 1 : 0;
                });;

                return area_region.area_prefectures;
            },
            // 県が選択された時
            selectAreaPrefecture: function(event,area_prefectures) {
                var area_prefecture_id = event.target.value;

                var value = area_prefectures.filter((area_prefecture) => {
                    return (area_prefecture.id == area_prefecture_id);
                });

                // 選ばれた県データに格納
                this.select_area_prefectures.push(value[0]);

                // 県を選択してくださいを非表示
                this.null_area_prefecture = 0;
            },
            // 県の選択を変更した時
            selectEditAreaPrefecture: function(event, area_region, before_select_area_prefecture_id) {
                let area_prefecture_id = event.target.value;
                let area_prefectures = area_region.area_prefectures;

                // 今選択された県データをvalueへ
                let value = area_prefectures.filter((area_prefecture) => {
                    return (area_prefecture.id == area_prefecture_id);
                });

                for(let i in this.select_area_prefectures) {
                    // 前に選択されてた県を今選択された県に変更
                    if (this.select_area_prefectures[i].id == before_select_area_prefecture_id) {
                        // プルダウン表示のためにプッシュ
                        area_region.area_prefectures.push(this.select_area_prefectures[i]);
                        this.select_area_prefectures[i] = value[0];
                    }
                }

                // 前に選択されてた県の市を削除
                this.checked_area_citys = this.checked_area_citys.filter((area_city) => {
                    return (area_city.area_prefecture_id !== before_select_area_prefecture_id);
                });
            },
            // 「県を選択してください」を表示するか判定
            showNullAreaPrefecture: function (area_region) {
                var value = this.select_area_prefectures.filter((area_prefecture) => {
                    return (area_prefecture.area_region_id == area_region.id);
                });

                if (area_region.area_prefectures.length == 0) {
                    return false;
                }

                // 地方IDが一致するものまたは、選択された県データの中にその地方のデータがなければ表示する(初期表示)
                if (this.null_area_prefecture == area_region.id || value.length == 0) {
                    return true;
                } else {
                    return false;
                }
            },
            changeAaareaCityALL(area_prefecture) {
                var area_prefecture_id = area_prefecture.id;
                var id = 'city-check-all' + area_prefecture_id;
                var check = document.getElementById(id).checked;

                var name = 'input[name=city-check' + area_prefecture_id +']';
                var arrayA = this.checked_area_citys;
                var arrayB = area_prefecture.area_city;
                if (check) {
                    // 第三階層全て選択
                    this.checked_area_citys = [...new Set( [...arrayA, ...arrayB] )];
                    $(name).prop('checked', true);
                } else {
                    // 第三階層全て選択解除
                    this.checked_area_citys = arrayA.filter((a_area_city) => {
                        return (a_area_city.area_prefecture_id != area_prefecture.id);
                    });
                    $(name).prop('checked', false);
                }
            },
        }
    }
</script>

